import LoadingSpinner from './LoadingSpinner.tsx';

export default LoadingSpinner;